import { useEffect, useRef } from "react";

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
let scriptLoading = null;

function loadScript() {
  if (window.grecaptcha && window.grecaptcha.render) return Promise.resolve();
  if (scriptLoading) return scriptLoading;
  scriptLoading = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://www.google.com/recaptcha/api.js?render=explicit";
    s.async = true;
    s.defer = true;
    s.onload = () => {
      const check = () => {
        if (window.grecaptcha && window.grecaptcha.render) resolve();
        else setTimeout(check, 100);
      };
      check();
    };
    document.head.appendChild(s);
  });
  return scriptLoading;
}

// onChange(token|null)
export default function Recaptcha({ onChange }) {
  const ref = useRef(null);
  const widgetId = useRef(null);

  useEffect(() => {
    let mounted = true;
    if (!SITE_KEY) return;
    loadScript().then(() => {
      if (!mounted || !ref.current || widgetId.current !== null) return;
      try {
        widgetId.current = window.grecaptcha.render(ref.current, {
          sitekey: SITE_KEY,
          callback: (token) => onChange && onChange(token),
          "expired-callback": () => onChange && onChange(null),
          "error-callback": () => onChange && onChange(null),
        });
      } catch (e) {
        /* already rendered */
      }
    });
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!SITE_KEY) return null;
  return <div ref={ref} data-testid="recaptcha-widget" className="mt-2" />;
}
